import React from 'react';

export default class Nothing extends React.Component {
    constructor() {
        super()
    }

    render() {
        return (
            <></>
        );
    }
}